// extracted by mini-css-extract-plugin
module.exports = {"navwrapper":"navbar-module--navwrapper--HJ49T","navItem":"navbar-module--navItem--3fry-","navIcon":"navbar-module--navIcon--1knNb","navBox":"navbar-module--navBox--32YeO"};